/* eslint-disable max-len */
import 'react';

const SysDocTemplateProjectSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="130px"
        height="173px"
        viewBox="0 0 130 173"
        {...props}
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-218.000000, -309.000000)">
                <g transform="translate(218.000000, 309.000000)">
                    <path d="M5.1277704,0.5 L124.87223,0.5 C126.513668,0.5 127.115921,0.653234454 127.717892,0.975172007 C128.281321,1.27649702 128.723503,1.71867923 129.024828,2.28210802 C129.346766,2.88407891 129.5,3.48633153 129.5,5.1277704 L129.5,5.1277704 L129.5,167.87223 C129.5,169.513668 129.346766,170.115921 129.024828,170.717892 C128.723503,171.281321 128.281321,171.723503 127.717892,172.024828 C127.115921,172.346766 126.513668,172.5 124.87223,172.5 L124.87223,172.5 L5.1277704,172.5 C3.48633153,172.5 2.88407891,172.346766 2.28210802,172.024828 C1.71867923,171.723503 1.27649702,171.281321 0.975172007,170.717892 C0.653234454,170.115921 0.5,169.513668 0.5,167.87223 L0.5,167.87223 L0.5,5.1277704 C0.5,3.48633153 0.653234454,2.88407891 0.975172007,2.28210802 C1.27649702,1.71867923 1.71867923,1.27649702 2.28210802,0.975172007 C2.88407891,0.653234454 3.48633153,0.5 5.1277704,0.5 L5.1277704,0.5 Z" id="矩形备份-18" stroke="#E6E7EB" fill="#FFFFFF"></path>
                    <path d="M4,0 L126,0 C128.209139,-4.05812251e-16 130,1.790861 130,4 L130,4 L130,4 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z" id="矩形" fill="#FF8D1A"></path>
                    <g transform="translate(16.000000, 50.000000)" fill="#FFECD9">
                        <rect x="0" y="0" width="98" height="8" rx="1"></rect>
                    </g>
                    <g transform="translate(16.000000, 64.000000)" fill="#FFECD9">
                        <rect id="矩形" x="0" y="0" width="98" height="8" rx="1"></rect>
                    </g>
                    <text fontFamily="PingFangSC-Regular, PingFang SC" fontSize="12" fontWeight="normal" fill="#77787A">
                        <tspan x="16" y="97">
                            {'\u672C\u6708'}
                        </tspan>
                    </text>
                    <rect fill="#FFECD9" x="16" y="105" width="42" height="16" rx="1"></rect>
                    <rect fill="#EEEFF1" x="16" y="125" width="42" height="16" rx="1"></rect>
                    <rect fill="#EEEFF1" x="16" y="145" width="42" height="16" rx="1"></rect>
                    <rect fill="#FFECD9" x="62" y="105" width="24" height="16" rx="1"></rect>
                    <rect fill="#EEEFF1" x="62" y="125" width="24" height="16" rx="1"></rect>
                    <rect fill="#EEEFF1" x="62" y="145" width="24" height="16" rx="1"></rect>
                    <rect fill="#FFECD9" x="90" y="105" width="24" height="16" rx="1"></rect>
                    <rect fill="#EEEFF1" x="90" y="125" width="24" height="16" rx="1"></rect>
                    <rect fill="#EEEFF1" x="90" y="145" width="24" height="16" rx="1"></rect>
                </g>
            </g>
        </g>
    </svg>
);
export default SysDocTemplateProjectSvg;
